import { toast } from 'react-toastify';
import { useCopyToClipboard } from 'react-use';
import { useEntityStore } from '@ContractBuilder/store';
import { useDrawerStore } from '@ContractBuilder/store/drawer.store';

import { useRenewalSummaryQuery } from '../hooks/useRenewalSummaryQuery';
import { useStartRenewalSummary } from '../hooks/useStartRenewalSummary';
import { buildCopyText } from '../utils/copy-text';
import { derivePanelState } from '../utils/derive-panel-state';
import { RenewalSummaryPanel } from '../views/RenewalSummaryPanel';

/** The Summary of Changes drawer on a renewal's Compare View. */
export const RenewalSummaryController = () => {
  const renewalId = useEntityStore(({ submission }) => submission?.id) ?? '';
  const closeDrawer = useDrawerStore(({ closeDrawer }) => closeDrawer);

  const { data, isError } = useRenewalSummaryQuery(renewalId, true);
  const { onStart, isStarting } = useStartRenewalSummary(renewalId);
  const state = derivePanelState(data, isError);
  const [, copyWithFallback] = useCopyToClipboard();

  const handleCopy = async () => {
    if (!data?.summary) return;
    const text = buildCopyText(data.summary.content);
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        // No async clipboard (insecure context, older browser): the execCommand route.
        copyWithFallback(text);
      }
      toast.success('Copied. Check it against the comparison before sending.', { autoClose: 5_000 });
    } catch {
      toast.error("Couldn't copy the summary. Try again.");
    }
  };

  return (
    <RenewalSummaryPanel
      state={state}
      data={data}
      isStarting={isStarting}
      onGenerate={onStart}
      onCopy={handleCopy}
      onClose={closeDrawer}
    />
  );
};
